<template>
    <div>
        <el-dialog top="5%" title="新增" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="阶段" prop="FName">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                 <el-form-item label="是否目录" prop="FIsTask">
                    <el-radio-group v-model="form.FIsTask" @change="changeIsTask">
                        <el-radio :label="0" >目录</el-radio>
                        <el-radio :label="1" >节点</el-radio> 
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排序" prop="FSort">
                    <el-input type="number" v-model="form.FSort"></el-input>
                </el-form-item>
                 <el-form-item label="负责人" prop="FLeader">
                    <sy-select v-model="form.FLeader" valueKey="FID" labelKey = "FName"
                               optionData="server/system/User.ashx?cmd=GetUserOptions">
                    </sy-select>
                </el-form-item>
                <el-form-item label="计量方式" prop="FMeasurStandard">
                    <el-radio-group v-model="form.FMeasurStandard">
                        <el-radio :label="1" >百分比</el-radio>
                        <el-radio :label="2" >数量</el-radio> 
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="计时标准" prop="FTimeType">
                    <el-radio-group v-model="form.FTimeType" @change="timeTypeChange">
                        <el-radio :label="1" >时</el-radio>
                        <el-radio :label="2" >秒</el-radio> 
                    </el-radio-group>
                </el-form-item>
                   <el-form-item label="标准用时(秒)" prop="FSTDTime">
                    <el-input style="width:20%;" v-if="form.FTimeType==1" type="number" v-model="hours" min="0"></el-input><span v-if="form.FTimeType==1">时</span>
                    <el-input style="width:20%;" v-if="form.FTimeType==2"  type="number" v-model="seconds" min="0"></el-input><span v-if="form.FTimeType==2">秒</span>
                 </el-form-item>
                   <el-form-item label="要求说明" prop="FRemark" v-if="istask">
                   <VueUEditor @ready="editorReady" style="width:98%;height:450px;"></VueUEditor>
                </el-form-item>
              <el-form-item label="图片" prop="FPic" v-if="istask">
                <sy-card-upload v-model="form.FPic"></sy-card-upload>
              </el-form-item>
                <el-form-item label="视频" prop="FVideo" v-if="istask">
                <sy-doc-upload v-model="form.FVideo"></sy-doc-upload>
              </el-form-item>
               
                <!-- <el-form-item label="备注" prop="FNote" >
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item> -->
              
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    import VueUEditor from '../../components/UEditor';
    export default {
        components: { VueUEditor },
        mixins: [mixin],
        data() {
            return {
                form: {},
                rules: {
                    FName: [{required: true,message: '请填写阶段', trigger: 'blur'}],
                },
                loading:false,
                editFormVisible:false,
                istask:true,
                hours:0,
                minutes:0,
                seconds:0
            }
        },
        methods: {
            _openEdit(record) {
                this.editFormVisible = true;
                this.form = Object.assign({Note:''},record);
                if(this.form.FTimeType==1){
                    this.hours = (this.form.FSTDTime/3600).toFixed(1)
				 }
						 
				if(this.form.FTimeType==2){
                     this.seconds =  (this.form.FSTDTime)
				 }
                this.istask = record.FIsTask
              
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form ={FID:0,FSort:0,FMouldId:0,FIsTask:1,Note:'',FRemark:'',FPic:'',FNote:'',FVideo:'',FTimeType:1,FMeasurStandard:1};
                this.form.FMouldId= record.FJobID;
                this.form.FParentId = record.PID?record.PID:0
            },
            save:function () {
               
                this.form.FRemark = this.form.Note
                if(this.hours==''||this.hours<0) this.hours=0
                if(this.minutes==''||this.minutes<0) this.minutes=0
                if(this.seconds==''||this.seconds<0) this.seconds=0
                if(this.form.FTimeType==1){ this.form.FSTDTime = parseInt(this.hours*3600)}
                if(this.form.FTimeType==2){ this.form.FSTDTime = parseInt(this.seconds)}
                
                let url = "server/business/ProjectMould.ashx?cmd=SaveDetail"
                util.saveForm(url,this.$refs.form,this.form,this.loadFn("loading"),result=> {
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            },
            changeIsTask(val){
                console.log(val)
                if(val==1){
                    this.istask=1
                }
                else{
                    this.istask=0
                }
            },
            timeTypeChange(val){
                if(this.form.FTimeType==2){
					this.seconds=this.hours*3600
				}
				else{
					this.hours=(this.seconds/3600).toFixed(1)
				}
            },
              editorReady (editorInstance) {
                debugger
                editorInstance.setContent(this.form.FRemark);
                editorInstance.addListener('contentChange', () => {
                    console.log(1111)
                     console.log(editorInstance.getContent())
                    this.form.Note=editorInstance.getContent();

                });
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/ProjectMouldDetail_Edit.vue